import swal from "sweetalert2"

export const Success = text => {
  swal({
    type: "success",
    title: "เรียบร้อย",
    text: text,
    showConfirmButton: false
  })
}

export const SuccessCallback = (text, time, callback) => {
  var datas = {
    type: "success",
    title: "เรียบร้อย",
    text: text,
    focusConfirm: false,
    confirmButtonColor: "#8bc34a"
  }
  if (time || time > 0) {
    datas.timer = time
    datas.showConfirmButton = false
  } else {
    datas.confirmButtonText = "ทราบ"
  }
  swal(datas).then(result => {
    if (result.value) {
      if (callback) {
        callback()
      }
    } else if (result.dismiss === "timer" || result.dismiss === "overlay") {
      if (callback) {
        callback()
      }
    }
  })
}

export const SuccessConfirm = (text, confirmButtonText, callback) => {
  var datas = {
    type: "success",
    title: "เรียบร้อย",
    text: text,
    focusConfirm: false,
    confirmButtonText: confirmButtonText,
    confirmButtonColor: "#8bc34a",
    showCancelButton: true,
    cancelButtonColor: "#666666",
    cancelButtonText: "ปิด"
  }
  swal(datas).then(result => {
    if (result.value) {
      if (callback) {
        callback(true)
      } else {
        callback(false)
      }
    }
  })
}
